"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ResultHeader = _interopRequireDefault(require("./ResultHeader"));

var _ResultInfo = _interopRequireDefault(require("./ResultInfo"));

var _ResultSection = _interopRequireDefault(require("./ResultSection"));

var _Tag = _interopRequireDefault(require("./Tag"));

var IconResultSection =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(IconResultSection, _React$Component);

  function IconResultSection() {
    (0, _classCallCheck2.default)(this, IconResultSection);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconResultSection).apply(this, arguments));
  }

  (0, _createClass2.default)(IconResultSection, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return _react.default.createElement(_ResultSection.default, {
        gradeType: props.gradeType
      }, _react.default.createElement(_Tag.default, props), _react.default.createElement(_ResultHeader.default, props), _react.default.createElement("div", {
        className: "result-icon icon " + props.resultIcon
      }), _react.default.createElement(_ResultInfo.default, props));
    }
  }]);
  return IconResultSection;
}(_react.default.Component);

exports.default = IconResultSection;
IconResultSection.propTypes = {
  gradeType: _propTypes.default.string,
  resultHeader: _propTypes.default.string,
  resultIcon: _propTypes.default.string
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/result/IconResultSection.js
// module id = 297
// module chunks = 0